<template>
	<div class="row mt-5 mb-5">
		<div class="col-sm-12 position-relative">
			<div class="row">
				<div class="col-sm-12 mb-5">
					<div class="d-flex justify-content-between align-items-center">
						<div class="d-flex flex-column text-dark">
							<h4>GSTIN: 02AAHCG2493B1Z2</h4>
							<div class="img">
								<img src="@/assets/logo.png" alt="logo" />
							</div>
						</div>
						<div class="d-flex flex-column text-dark">
							<h3 class="text-center">CASH RECEIPT</h3>
							<div class="info">
								<h1 class="text-center">Global Trip Holidays Pvt. Ltd.</h1>
								<h6 class="text-center">
									(Approved by Govt. of Himachal Pradesh, Department of Tourism
									& Civil Aviation)
								</h6>
								<h5 class="text-center">
									Near State Bank of India, The Mall Manali-175131, Distt, Kullu
									(H.P.)
								</h5>
								<h5 class="text-center">
									E-mail: info@globaltripholidays.com, Website:
									www.globaltripholidays.com
								</h5>
							</div>
						</div>
						<div class="d-flex flex-column text-dark">
							<h4>Tel: +91-1902-253144</h4>
							<h4>Mob: +91-97365-00144</h4>
						</div>
					</div>
				</div>
				<div class="col-sm-12 mb-5">
					<div
						class="d-flex justify-content-between d-flex align-items-center justify-content-end text-dark"
					>
						<div
							class="justify-content-between d-flex align-items-center justify-content-end text-dark"
						>
							<h4 class="mb-0 me-3 pb-2">
								Bill No.
								<span class="text-decoration-underline"
									>{{ masterStore.state.data.leadNumber }}-{{ count + 1 }} </span
								>
								
							</h4>
						</div>

						<div
							class="justify-content-between d-flex align-items-center justify-content-end text-dark"
						>
							<p class="mb-0 me-3">Date</p>
							<BaseInput
								name="Date"
								type="date"
								v-model="data.receiptDate"
								:required="true"
								class="form-control form-control-lg dashInput"
								rules="required"
								:disabled="data?.verified"
							/>
						</div>
					</div>
				</div>
				<div
					class="form-group col-sm-3 mb-4 d-flex align-items-center justify-content-around text-dark"
				>
					<p class="mb-0">Received with thanks from</p>
					<BaseInput
						name="Customer Name"
						type="text"
						v-model="data.name"
						class="form-control form-control-lg dashInput"
						rules="required|min:3|max:60"
						:disabled="data?.verified"
					/>
				</div>
				<div
					class="form-group col-sm-2 mb-4 d-flex align-items-center text-dark"
				>
					<p class="mb-0 me-4">a sum of Rupees</p>
					<BaseInput
						name="Sum of rupees"
						type="text"
						v-model="data.sumOfRupees"
						:required="true"
						class="form-control form-control-lg dashInput"
						rules="required|min:3"
						:disabled="data?.verified"
					/>
				</div>
				<div
					class="form-group col-sm-2 mb-4 d-flex align-items-center text-dark"
				>
					<p class="mb-0 me-4">Advance</p>

					<BaseInput
						name="Advance"
						type="number"
						:min="1000"
						v-model="data.advance"
						class="form-control form-control-lg dashInput"
						rules="required"
						:disabled="data?.verified"
					/>
				</div>
				<div
					class="form-group col-sm-2 mb-4 d-flex align-items-center text-dark"
				>
					<p class="mb-0 me-4">Balance</p>

					<BaseInput
						name="Balance"
						type="number"
						:min="0"
						v-model="data.balance"
						class="form-control form-control-lg dashInput"
						rules="required"
						:disabled="data?.verified"
					/>
				</div>
				<div
					class="form-group col-sm-2 mb-4 d-flex align-items-center text-dark"
				>
					<p class="mb-0 me-4">Total Amount</p>

					<BaseInput
						name="Total Amount"
						type="number"
						:min="0"
						v-model="data.totalAmount"
						class="form-control form-control-lg dashInput"
						rules="required"
						:disabled="data?.verified"
					/>
				</div>

				<div
					class="form-group col-sm-4 col-md-5 mb-4 d-flex align-items-center justify-content-around text-dark"
				>
					<p class="mb-0 me-1">By</p>

					<div
						class="form-group col-sm-3 d-flex justify-content-space-between align-items-center"
					>
						<input
							class="form-check-input"
							type="checkbox"
							v-model="data.cash"
							id="flexCheckIndeterminate"
							value="cash"
							:disabled="data?.verified"
						/>
						<label
							class="form-check-label mx-1 pt-1 text-dark"
							for="flexCheckIndeterminate"
						>
							Cash
						</label>
					</div>
					<div
						class="form-group col-sm-3 d-flex justify-content-space-between align-items-center"
					>
						<input
							class="form-check-input"
							type="checkbox"
							v-model="data.cheque"
							id="flexCheckIndeterminate"
							value="cheque"
							:disabled="data?.verified"
						/>
						<label
							class="form-check-label mx-1 pt-1 text-dark"
							for="flexCheckIndeterminate"
						>
							Cheque
						</label>
					</div>

					<div
						class="form-group col-sm-3 d-flex justify-content-space-between align-items-center"
					>
						<input
							class="form-check-input"
							type="checkbox"
							v-model="data.online"
							id="flexCheckIndeterminate"
							value="online"
							:disabled="data?.verified"
						/>
						<label
							class="form-check-label mx-1 pt-1 text-dark"
							for="flexCheckIndeterminate"
						>
							Online
						</label>
					</div>
				</div>

				<div
					class="form-group col-sm-2 mb-4 d-flex justify-content-space-between align-items-center text-dark"
				>
			

					<BaseInput
						name="Date"
						type="date"
						v-model="data.paymentDate"
						class="form-control form-control-lg dashInput"
						rules="required"
						:disabled="data?.verified"
					/>
				</div>

				<div
					class="form-group col-sm-4 col-md-6 mb-4 d-flex justify-content-space-between align-items-center text-dark"
				>
					<p class="mb-0 me-4">against</p>

					<div
						class="form-group col-sm-2 d-flex justify-content-space-between align-items-center"
					>
						<input
							class="form-check-input"
							type="checkbox"
							v-model="data.full"
							id="flexCheckIndeterminate"
							value="full"
							:disabled="data?.verified"
						/>
						<label
							class="form-check-label mx-1 pt-1 text-dark"
							for="flexCheckIndeterminate"
						>
							Full
						</label>
					</div>
					<div
						class="form-group col-sm-2 d-flex justify-content-space-between align-items-center"
					>
						<input
							class="form-check-input"
							type="checkbox"
							v-model="data.part"
							id="flexCheckIndeterminate"
							value="part"
							:disabled="data?.verified"
						/>
						<label
							class="form-check-label mx-1 pt-1 text-dark"
							for="flexCheckIndeterminate"
						>
							Part
						</label>
					</div>

					<div
						class="form-group col-sm-3 d-flex justify-content-space-between align-items-center"
					>
						<input
							class="form-check-input"
							type="checkbox"
							v-model="data.advancePay"
							id="flexCheckIndeterminate"
							value="advance"
							:disabled="data?.verified"
						/>
						<label
							class="form-check-label mx-1 pt-1 text-dark"
							for="flexCheckIndeterminate"
						>
							Advance
						</label>
					</div>
					<p class="mb-0 me-4">Invoice or Bill No.</p>
				</div>

				<div
					class="form-group col-sm-3 mb-4 justify-content-space-between align-items-center text-dark"
				>
					<BaseInput
						name="Against"
						type="text"
						v-model="data.againstBillNo"
						class="form-control form-control-lg dashInput"
						rules="required"
						:disabled="data?.verified"
					/>
				</div>
			</div>
			<span
				v-if="count !== 0"
				@click="$emit('removeComponent', count)"
				class="mx-2 position-absolute top-100 start-100 translate-middle badge rounded-pill bg-danger cursor-pointer width"
				><i class="bi bi-x"></i
			></span>
		</div>
	</div>
</template>
<script>
	import { reactive, inject, watch } from "vue";
	import BaseInput from "./BaseInput.vue";
	import BaseButton from "./BaseButton.vue";
	export default {
		name: "PaymentReceipt",
		components: {
			BaseInput,
			BaseButton,
		},
		emits: ["removeComponent", "updateData"],
		props: {
			count: { type: Number, default: 0 },
			defaultData: { type: [Array, Object, String], default: "" },
		},

		setup: (props, { emit }) => {
			const store = inject("store");
			const masterStore = inject("masterStore");

			const data = reactive({
				count: props.count + 1,
				leadId: masterStore.state.data._id,
				billNumber: `${masterStore.state.data.leadNumber}-${props.count + 1}`,
				receiptDate: null,
				name: `${masterStore.state.data.name.salutation} ${masterStore.state.data.name.firstName} ${masterStore.state.data.name.lastName}`,
				sumOfRupees: null,
				advance: null,
				balance: null,
				totalAmount: null,
				cash: false,
				cheque: false,
				online: false,
				paymentDate: null,
				full: false,
				part: false,
				advancePay: false,
				againstBillNo: null,
				verified: false,
				rejected: false,
				verifiedBy: null,
				createdBy: store.state.user.id
			});

			

			watch(
				() => data,
				(preValue, newValue) => {
					if (
						data.receiptDate &&
						data.paymentDate &&
						data.sumOfRupees &&
						data.totalAmount &&
						(data.cash || data.cheque || data.online) &&
						(data.full || data.part || data.advancePay)
					) {
						emit("updateData", { index: props.count, data });
					}
				},
				{ deep: true },
			);

			if (props.defaultData instanceof Object) {
				let keys = Object.keys(data);

				keys.map((key) => {
					data[key] = props.defaultData[key] || data[key];
				});

				data.paymentDate = props.defaultData?.paymentDate.split("T")[0];
				data.receiptDate = props.defaultData?.receiptDate.split("T")[0];
			}

			return {
				store,
				masterStore,
				data,
			};
		},
	};
</script>
<style scoped>
	.img,
	.img > img {
		height: 150px;
	}
	.width {
		width: 30px;
	}
</style>
